import { render } from "./MessagesButton.vue?vue&type=template&id=48545599&scoped=true"
import script from "./MessagesButton.vue?vue&type=script&lang=js"
export * from "./MessagesButton.vue?vue&type=script&lang=js"

import "./MessagesButton.vue?vue&type=style&index=0&id=48545599&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48545599"]])

export default __exports__